module.exports = __webpack_public_path__ + "img/rural.c403807a.svg";